import { PropComponentMode } from "../PropertyInterfaces";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";
import { useState } from "react";

export interface ReportPropertyProps {
	id: number | string;
	mode?: PropComponentMode;
	isEspecial?: Boolean;
	isDisabledProperty?: boolean;
	type?: "default" | "justIcon";
}

const COMPLAINT_MUTATION = gql`
	mutation createComplait($input: ComplaintInput!) {
		issueComplaint(input: $input)
	}
`;

export const useReportProperty = ({ id, mode }: ReportPropertyProps) => {
	const [reasons, setReasons] = useState([]);
	const [sendComplaint] = useMutation(COMPLAINT_MUTATION);

	const options = [
		{ id: 1, text: "Precio desactualizado" },
		{ id: 2, text: "Contenido inapropiado" },
		{ id: 3, text: "Ubicación incorrecta" },
		{ id: 4, text: "Información incorrecta" },
		{ id: 5, text: "Foto en baja calidad" },
		{ id: 6, text: "Propiedad sin imagen" },
	];

	const sendReport = async () => {
		return sendComplaint({
			variables: {
				input: {
					reasonsID: reasons,
					propertyID: id,
				},
			},
		});
	};

	return {
		reasons: { value: reasons, set: setReasons },
		options,
		sendReport,
	};
};
